import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { catchError, map, throwError } from "rxjs";
import { FormService } from "src/app/services/form.service";
import { GenreService } from "src/app/services/genre.service";
import { SeoServiceService } from "src/app/services/seo-service.service";

@Component({
  selector: "app-book-sessions-form",
  templateUrl: "./book-sessions-form.component.html",
  styleUrls: ["./book-sessions-form.component.scss"],
})
export class BookSessionsFormComponent implements OnInit {
  formGroup: FormGroup;
  genre: any;

  constructor(
    private genreSevice: GenreService,
    private formBuilder: FormBuilder,
    private form: FormService,
    private snackbar: MatSnackBar,
    private seoService: SeoServiceService
  ) {
    this.formGroup = this.formBuilder.group({
      name: ["", Validators.required], // Add necessary validators
      gender: ["", Validators.required],
      ageGroup: ["", Validators.required],
      genreSelection: ["", Validators.required],
      mobileNumber: ["", [Validators.required, Validators.maxLength(10)]],
      email: ["", [Validators.required, Validators.email]],
      comment: ["", Validators.required],
    });
  }

  ngOnInit(): void {
    this.seoService.createLinkForCanonicalURL();
    this.loadList();
  }

  loadList() {
    this.genreSevice
      .getgenre()
      .pipe(
        map((res: any) => {
          this.genre = res.details;
        }),
        catchError((error) => {
          return throwError(error.massage || error);
        })
      )
      .subscribe();
  }

  onSubmit(): void {
    if (this.formGroup.valid) {
      const formData = this.formGroup.value;
      const body = {
        name: formData.name,
        email: formData.email,
        message: formData.comment,
        mobile: formData.mobileNumber,
        gender: formData.gender,
        genre: formData.genreSelection,
        preference: "",
        age_group: formData.age_group,
      };
      this.form.bookSession(body).subscribe((res: any) => {
        if (res.error === false) {
          this.snackbar.open(res.message, "Ok", { duration: 4000 });
        } else {
        }
      });
      this.formGroup.reset();
    } else {
      this.formGroup.markAllAsTouched();
    }
  }
}
